import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { OrderManagerApi } from '../api/orderManagerApi';
import { OrderProgressType } from '../types';

export const QUERY_KEY_ORDER_PROGRESS = 'QUERY_KEY_ORDER_PROGRESS';
export const useOrderProgress = (
  orderId: number,
  options?: UseQueryOptions<
    OrderProgressType,
    AxiosError,
    OrderProgressType,
    [typeof QUERY_KEY_ORDER_PROGRESS, string | number]
  >,
) => {
  return useQuery({
    queryKey: [QUERY_KEY_ORDER_PROGRESS, orderId],
    queryFn: async () => await OrderManagerApi.fetchOrderProgress(orderId),
    ...options,

    // we don't want this data to cache, want a fresh request every time the user hovers to see progress
    staleTime: 0,
  });
};
